import { createCorsConfigSource } from './cors.ts';
import type { RouteConfig } from './route.ts';
import security, { type HttpSecurityConfig } from '../server/security/config.ts';
import { and, pattern, type ServerWebExchangeMatcher, upgradeMatcher } from '../server/util/matchers.ts';
import type { CorsConfigSource } from '../server/cors.ts';
import type { Middleware } from '../server/types.ts';
import type { AuthorizationRule } from '../../types/auth';

export function createSecurityConfig(context: RouteConfig): HttpSecurityConfig {
    const authorize: HttpSecurityConfig['authorize'] = [];
    const defaultAccess: AuthorizationRule = {access: context.authConfig?.type !== 'none' ? 'authenticated' : 'permitted'};

    for (const [path, route] of context.sockets) {
        const rule = route.authorize ?? defaultAccess;
        let matcher: ServerWebExchangeMatcher = pattern(path, {method: 'GET'});
        matcher = and([upgradeMatcher, matcher]);
        authorize.push([matcher, rule]);
    }
    authorize.push([pattern('/', {method: 'GET'}), {access: 'permitted'}]);
    authorize.push([pattern('/favicon.ico', {method: 'GET'}), {access: 'permitted'}]);
    authorize.push([pattern('/health', {method: 'GET'}), {access: 'permitted'}]);
    if (context.authorize.length > 0) {
        authorize.push(...context.authorize);
    }

    authorize.push(['any-exchange', defaultAccess]); // default rule for all other exchanges
    return {
        authorize,
        cors: {
            disabled: context.corsConfig === false,
        },
        basic: {
            disabled: context.authConfig?.type !== 'basic',
            ...context.authConfig?.basic,
        },
        jwt: {
            disabled: context.authConfig?.type !== 'oauth2',
            ...context.authConfig?.oauth2?.jwt
        }
    }
}

export async function httpSecurity(context: RouteConfig): Promise<Middleware> {
    const corsConfigSource: CorsConfigSource = createCorsConfigSource(context);
    const config = createSecurityConfig(context);
    const {storage} = context;
    return security(config, {storage, corsConfigSource})
}
